<template>
  <img
    class="logo"
    src="@/assets/images/trello-logo-blue.svg"
    alt="trello-logo-blue"
  >
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({})
</script>

<style lang="scss" scoped></style>
